import productEnum from "./modules/productEnum";
import customerTypeEnum from "./modules/customerTypeEnum";

export default {
  productEnum,
  customerTypeEnum
}



// WEBPACK FOOTER //
// ./src/enums/index.js